import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    dispatchValidationBase: {
      fontSize: 20,
      padding: '10px',
      textAlign: 'center'
    },
    dispatchValidationError: {
      color: '#ED4337'
    },
    dispatchValidationSuccess: {
      color: '#33A820'
    },
    dispatchZones: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    zoneStatus: {
      display: 'flex',
      marginTop: '40px',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      width: '100%',
      flexWrap: 'wrap'
    },
    zoneStatusItem: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px'
    },
    zoneListItem: {
      paddingTop: '0px',
      marginTop: '-8px'
    }
  })
)
